export { default } from "./ShareConfirmation";
